module.exports = __webpack_public_path__ + "static/img/register.ff1b64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/other/register.png
// module id = gOA9
// module chunks = 1